import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Query from './Query';
function QueriesSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <Query filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default QueriesSearch;
